var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-button',{attrs:{"icon":"plus","type":_vm.type,"size":_vm.size},on:{"click":e => _vm.$emit('click', e)}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }